import {wupoServerUri} from '../Api';

const getFoodData = async(requestObject, jwtToken) => {
  
    console.log(requestObject);
  
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getFoodData`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwtToken}`,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};

const getFoodTotalProductionValue = async(requestObject, jwtToken) => {

    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getFoodTotalProductionValue`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
          "Content-Type": "application/json; charset=UTF-8",
        },
    })
    .catch((error) => {
      console.log("Error: " + error);
    });

    console.log(response.status);
    if(response.status === 200 ){
      const body = await response.json();
      console.log(body);
      return body;
    }

    return null;
  }

  const getFoodAverageNetIncomePerFarm = async(requestObject, jwtToken) => {

    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getFoodAverageNetIncomePerFarm`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
          "Content-Type": "application/json; charset=UTF-8",
        },
    })
    .catch((error) => {
      console.log("Error: " + error);
    });

    console.log(response.status);
    if(response.status === 200 ){
      const body = await response.json();
      console.log(body);
      return body;
    }

    return null;
  }

  const getFoodOperatingExpenseRatio = async(requestObject, jwtToken) => {
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/getFoodOperatingExpenseRatio`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
          "Content-Type": "application/json; charset=UTF-8",
        },
    })
    .catch((error) => {
      console.log("Error: " + error);
    });

    console.log(response.status);
    if(response.status === 200 ){
      const body = await response.json();
      console.log(body);
      return body;
    }

    return null;
  }

  const docAnalyzer = async(formData, jwtToken) => {

    console.log(formData.get("file"));
    console.log(formData.get("file").name);
    // const response = await fetch(`${wupoServerUri.devnet}/api/secure/docAnalyzer`, {
    const response = await fetch(`${wupoServerUri.devnet}/api/secure/createReport`, {
      method: "POST",
      body: formData,
      credentials: 'include',
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    }).catch((error) => {
      console.log("Error: " + error);
    });

    if(response && response.status === 200) {
      const body = await response.json();
      console.log(body);
      return body;
    }

    return null;
  }

  const createReport = async(formData, jwtToken) => {
    try {
      console.log(formData.get("reportRequest"));
      console.log(formData.get("file").name);
      console.log(formData.get("file"));
      const response = await fetch(`${wupoServerUri.devnet}/api/secure/createReport`, {
        method: "POST",
        body: formData,
        // credentials: 'include',
        headers: {
          "Authorization": `Bearer ${jwtToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = "report_datalove.pdf";
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url); // Free up memory by revoking the object URL
      
      return "ok";
    } catch (error) {
      console.error("Error downloading report:", error);
      return null;
    }
  }

  const generateClientMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateClientMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch client metrics:', response.statusText);
            return null;
        }

        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching client metrics:', error);
        return null;
    }
  };

  const generateSatisfactionMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateSatisfactionMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch satisfaction metrics:', response.statusText);
            return null;
        }
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching satisfaction metrics:', error);
        return null;
    }
  };

  const generateLoginMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateLoginMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch login metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching login metrics:', error);
        return null;
    }
  };

  const generateSurveyMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateSurveyMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch survey metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching survey metrics:', error);
        return null;
    }
  };

  const generateVisitMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateVisitMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch visit metrics:', response.statusText);
            return null;
        }
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching visit metrics:', error);
        return null;
    }
  };

  const generateServiceTimeMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateServiceTimeMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch service time metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching service time metrics:', error);
        return null;
    }
  };

  const generateSlotUtilizationMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateSlotUtilizationMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch slot utilization metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching slot utilization metrics:', error);
        return null;
    }
  };

  const generateUniqueUsersMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateUniqueUsersMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch unique users metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching unique users metrics:', error);
        return null;
    }
  };

  const generateNewUsersMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateNewUsersMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch new users metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching new users metrics:', error);
        return null;
    }
  };

  const generateReturningUsersMetrics = async (token) => {
    try {
        const response = await fetch(`${wupoServerUri.devnet}/api/secure/generateReturningUsersMetrics`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            console.error('Failed to fetch returning users metrics:', response.statusText);
            return null;
        }
        
        const body = await response.json();
        console.log(body);
        return body;
    } catch (error) {
        console.error('Error fetching returning users metrics:', error);
        return null;
    }
  };



  const getNationalCensusData = async (requestObject, token) => {
    try {
      console.log("Making national census request for year:", requestObject.year);
      const response = await fetch(`${wupoServerUri.devnet}/api/secure/census/national`, {
        method: "POST",
        body: JSON.stringify({ year: requestObject.year }),
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        console.error('Failed to fetch national census data:', response.statusText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data) {
        console.error("No data in response");
        throw new Error('No data received from API');
      }

      // Log the structure of the response
      console.log("Response structure:", {
        hasData: !!data,
        dataType: typeof data,
        dataKeys: Object.keys(data),
        dataArray: Array.isArray(data.data),
        dataLength: data.data?.length
      });
      
      const validatedData = (data.data || []).map(item => {
        const population = parseFloat(item.population || item.value);
        const state = item.stateCode?.padStart(2, '0');
        console.log("Parsed population:", population, "State:", state);
        return {
          state: state,
          population: population
        };
      }).filter(item => item !== null);
      
      console.log("Validated data:", validatedData);
      return validatedData;
    } catch (error) {
      console.error("Error fetching national census data:", error);
      throw error;
    }
  };

  const getStateCensusData = async (requestObject, token) => {
    try {
      console.log("Making state census request for state:", requestObject.stateCode, "year:", requestObject.year);
      const response = await fetch(`${wupoServerUri.devnet}/api/secure/census/state`, {
        method: "POST",
        body: JSON.stringify(requestObject),
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        console.error('Failed to fetch state census data:', response.statusText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      const processedData = data.data.map(item => ({
        ageGroup: item.ageGroup,
        population: item.population,
        race: {
          [item.race]: item.population
        },
        sex: {
          [item.sex]: item.population
        }
      }));
      
      console.log("Processed state data:", processedData);
      return processedData;
    } catch (error) {
      console.error("Error fetching state census data:", error);
      throw error;
    }
  };


  // Food security Census Tracts
  // Fetch census tracts with optional filtering
  const getCensusTracts = async (filters = {}, token) => {
    const queryParams = new URLSearchParams();
    
    // Only add parameters that have actual values
    if (filters.state && filters.state !== '') queryParams.append('state', filters.state);
    if (filters.county && filters.county !== '') queryParams.append('county', filters.county);
    if (filters.urban !== undefined && filters.urban !== null && filters.urban !== '') 
      queryParams.append('urban', filters.urban);
    
    try {
      console.log(`Making request to: ${wupoServerUri.devnet}/api/secure/census/tracts?${queryParams.toString()}`);
      const response = await fetch(
        `${wupoServerUri.devnet}/api/secure/census/tracts?${queryParams.toString()}`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API Error (${response.status}):`, errorText);
        throw new Error(`API responded with status ${response.status}: ${errorText}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching census tracts:", error);
      throw error;
    }
  };

  // Fetch aggregated census data
  const getAggregatedCensusData = async (groupBy, state, token) => {
    const queryParams = new URLSearchParams();
    queryParams.append('groupBy', groupBy);
    if (state) queryParams.append('state', state);
    
    try {
      const response = await fetch(
        `${wupoServerUri.devnet}/api/secure/census/aggregated?${queryParams.toString()}`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching aggregated census data:", error);
      throw error;
    }
  };

  // Fetch census metrics
  const getCensusMetrics = async (filters = {}, token) => {
    const queryParams = new URLSearchParams();
    
    if (filters.state) queryParams.append('state', filters.state);
    if (filters.county) queryParams.append('county', filters.county);
    
    try {
      const response = await fetch(
        `${wupoServerUri.devnet}/api/secure/census/metrics?${queryParams.toString()}`, 
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching census metrics:", error);
      throw error;
    }
  };

  /**
   * Fetches food insecurity data by county
   */
  const getFoodInsecurityData = async (filters = {}, token) => {
    try {
      let url = `${wupoServerUri.devnet}/api/secure/census/food-insecurity`;
      
      // Add query parameters
      const params = new URLSearchParams();
      if (filters.state) params.append('state', filters.state);
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      console.log("🔍 Debug - Making request to:", url);
      console.log("🔍 Debug - Token provided:", !!token);
  
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`  
      };
      
      //console.log("🔍 Debug - Headers:", JSON.stringify(headers));
      
      const response = await fetch(url, {
        method: 'GET',
        headers,
        credentials: 'include'  
      });
      
      console.log("🔍 Debug - Response status:", response.status);
      console.log("🔍 Debug - Response type:", response.headers.get('content-type'));
      
      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('html')) {
          console.error("🚨 Received HTML instead of JSON - likely an authentication error");
          const htmlText = await response.text();
          console.error("🚨 HTML snippet:", htmlText.substring(0, 100));
          throw new Error(`Authentication error: Received HTML instead of JSON (${response.status})`);
        } else {
          const errorText = await response.text();
          console.error(`🚨 API error (${response.status}):`, errorText);
          throw new Error(`API responded with status ${response.status}`);
        }
      }
      
      const data = await response.json();
      console.log("✅ Data successfully received, count:", data.length);
      console.log("✅ Data:", data);
      return data;
    } catch (error) {
      console.error('❌ Error fetching food insecurity data:', error);
      throw error;
    }
  };

  /**
   * Fetches the top food insecure counties
   * @param {string} token - JWT token for authentication
   * @returns {Promise<Array>} - Array of top food insecure counties
   */
  const getTopFoodInsecurityCounties = async (token) => {
    try {
      const response = await fetch(
        `${wupoServerUri.devnet}/api/secure/census/food-insecurity/top`,
        { 
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          } 
        }
      );
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API error (${response.status}): ${errorText}`);
        throw new Error(`API responded with status ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching top food insecure counties:", error);
      throw error;
    }
  };

  
  export {
    getStateCensusData,
    getNationalCensusData,
    getFoodData,
    getFoodTotalProductionValue,
    getFoodAverageNetIncomePerFarm,
    getFoodOperatingExpenseRatio,
    docAnalyzer,
    createReport,
    getCensusTracts,
    getAggregatedCensusData,
    getCensusMetrics,
    getFoodInsecurityData,
    getTopFoodInsecurityCounties,
    generateClientMetrics,
    generateSatisfactionMetrics,
    generateLoginMetrics,
    generateSurveyMetrics,
    generateVisitMetrics,
    generateServiceTimeMetrics,
    generateSlotUtilizationMetrics,
    generateUniqueUsersMetrics,
    generateNewUsersMetrics,
    generateReturningUsersMetrics
  };